var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "row",
    },
    _vm._l(_vm.gameItems, function (game) {
      return _c(
        "div",
        {
          staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3",
        },
        [
          _c("soidown-item", {
            attrs: {
              id: game.id,
              status: game.status,
              "game-slug": game.master.slug,
              "close-at": game.display_closed_at,
              title: game.name
                ? game.name + " " + game.readable_edition
                : game.master.name + " " + game.readable_edition,
              "readable-edition": game.readable_edition,
              "seconds-left":
                game.diff_in_seconds > 0
                  ? game.status == "open"
                    ? game.diff_in_seconds
                    : 0
                  : 0,
              "game-link":
                _vm.slug != ""
                  ? `../../lotto/` + game.id
                  : `./lotto/` + game.id,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }